import { merge } from 'lodash'

export const xAxis = (options = {}, color = '#9A9FAE', fontSize = '9px') => {
  const base = {
    labels: {
      style: { color, fontSize }
    },
    lineColor: 'hsl(225deg 11% 90%)'
  }

  return merge(base, options)
}

export const yAxis = (
  options = {},
  color = '#9A9FAE',
  fontSize = '9px',
  gridLineColor = 'rgba(154, 159, 174, 0.4)'
) => {
  const base = {
    tickAmount: 4,
    labels: {
      style: { color, fontSize }
    },
    gridLineColor,
    gridLineDashStyle: 'dash'
  }

  return merge(base, options)
}

export const chart = (options = {}) => {
  const base = {
    title: false,
    backgroundColor: 'transparent',
    spacingLeft: 0,
    spacingBottom: 0
  }

  return merge(base, options)
}
